import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const acceptOfferFunction = createAsyncThunk(
  "offer/acceptOfferFunction",
  async (
    { construction_preview_id, company_id, device, wallete_pay },
    { rejectWithValue }
  ) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/accept_price`,
        { construction_preview_id, company_id, device, wallete_pay },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.status) {
        return rejectWithValue(response.message);
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

export const refuseOfferFunction = createAsyncThunk(
  "offer/refuseOfferFunction",
  async (
    { construction_preview_id, company_id, device },
    { rejectWithValue }
  ) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/refuse_offer`,
        { construction_preview_id, company_id, device },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.orders;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

export const payWalletFunction = createAsyncThunk(
  "pay/payWalletFunction",
  async ({ type, construction_preview_id }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/wallete_pay`,
        { type, construction_preview_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error pay preview:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to pay preview"
      );
    }
  }
);

const initialState = {
  acceptOffer: null,
  refuseOffer: null,
  payWallet: null,
  status: "idle",
  error: null,
};

const acceptOfferSlice = createSlice({
  name: "acceptOffer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(acceptOfferFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(acceptOfferFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.acceptOffer = action.payload;
      })
      .addCase(acceptOfferFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(refuseOfferFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(refuseOfferFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.refuseOffer = action.payload;
      })
      .addCase(refuseOfferFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(payWalletFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(payWalletFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.payWallet = action.payload;
      })
      .addCase(payWalletFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default acceptOfferSlice.reducer;
